// extracted by mini-css-extract-plugin
export default {"app":"App_app__T14To","main":"App_main__sBUyh","pageLoader":"App_pageLoader__XROiv","spinner":"App_spinner__uJYkV","spin":"App_spin__uad04"};